import { z } from "zod";
import {
  AUTO_APPROVAL,
  AUTO_APPROVAL_LEVEL,
  BUDGET_QTY,
  FINANCIAL_YEAR,
  GL_MASTER_ID,
  TOLERANCE,
  TRANSACTION_RATE,
  YEARLY_AMT,
} from "./consts";

export const schema = z.object({
  [FINANCIAL_YEAR]: z.string().optional(),
  [GL_MASTER_ID]: z.string().min(1, "This field is required"),
  [TRANSACTION_RATE]: z.string().optional(),
  [BUDGET_QTY]: z.string().optional(),
  [TOLERANCE]: z.string().optional(),
  [YEARLY_AMT]: z
    .string()
    .min(1, "This field is required"),
  [AUTO_APPROVAL]: z.boolean().optional(),
  [AUTO_APPROVAL_LEVEL]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
